var mayUtility = {}
var globalConfig = webConfig;// eslint-disable-line no-undef
mayUtility.isEmpty = function (val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === 'boolean') return false;

    if (typeof val === 'number') return !val;

    if (val instanceof Error) return val.message === '';

    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]':
            return !val.length;

        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]': {
            return !val.size;
        }
        // Plain Object
        case '[object Object]': {
            return !Object.keys(val).length;
        }
    }

    return false;
}

mayUtility.getBaseUrl = function () {
    if (globalConfig == undefined) {
        console.error("缺少配置文件web-config.js");
        return
    }

    if (!globalConfig.baseURL) {
        globalConfig.baseURL = window.location.protocol + "//" + window.location.hostname;
    }

    if (!globalConfig.port || (globalConfig.port && globalConfig.port == '')) {
        globalConfig.port = window.location.port;
    }

    var baseURL = globalConfig.baseURL + ":" + globalConfig.port;

    if (!isURL(baseURL)) {
        console.error('globalConfig.baseURL不是有效的url！')
        return
    }

    if (baseURL.indexOf('http') == -1) {//不以http开头，要补上
        baseURL = "http://" + baseURL;
    }

    if (baseURL[baseURL.length] != '/')//不以/结尾要补上
        baseURL += '/';


    return baseURL

    //判断是否正确的url格式
    function isURL(str_url) {
        var strRegex = '^((https|http|ftp|rtsp|mms)?://)'
            + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@ 
            + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184 
            + '|' // 允许IP和DOMAIN（域名） 
            + '([0-9a-z_!~*\'()-]+.)*' // 域名- www. 
            + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名 
            + '[a-z]{2,6})' // first level domain- .com or .museum 
            + '(:[0-9]{1,4})?' // 端口- :80 
            + '((/?)|' // a slash isn't required if there is no file name 
            + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
        var re = new RegExp(strRegex);
        //re.test() 
        if (re.test(str_url)) {
            return true;
        } else {
            return false;
        }
    }
}

export default mayUtility;